var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGetquote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#F2F5F9",
    stroke: "#E5EBF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 12.5H27.4998C27.7209 12.5 27.9328 12.5878 28.0891 12.7441C28.2454 12.9004 28.3332 13.1123 28.3332 13.3333V26.6667C28.3332 26.8877 28.2454 27.0996 28.0891 27.2559C27.9328 27.4122 27.7209 27.5 27.4998 27.5H12.4998C12.2788 27.5 12.0669 27.4122 11.9106 27.2559C11.7543 27.0996 11.6665 26.8877 11.6665 26.6667V13.3333C11.6665 13.1123 11.7543 12.9004 11.9106 12.7441C12.0669 12.5878 12.2788 12.5 12.4998 12.5V12.5ZM26.6665 16.0317L20.0598 21.9483L13.3332 16.0133V25.8333H26.6665V16.0317ZM13.759 14.1667L20.0507 19.7183L26.2515 14.1667H13.759Z",
    fill: "#003C8A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetquote);
export default __webpack_public_path__ + "static/media/getquote.bb19983994c9694d5c5ddfb44171f562.svg";
export { ForwardRef as ReactComponent };